<div class="wrapper">
    <h1 mat-dialog-title style="display: inline-block; cursor: move">
        Select a builder
    </h1>
    <br />
    <div class="search-register-area">
        <label class="search-input">
            Search:
            <input
                type="text"
                name="search"
                [(ngModel)]="searchText"
                (input)="filterBuilders($event)"
        /></label>
    </div>
    <table>
        <tr>
            <th class="table-title">Builder Name</th>
        </tr>
    </table>
    <div class="vesselBuilderSelectTable">
        <table>
            <tr *ngFor="let d of filteredBuilders" (click)="rowClick(d)">
                <td>{{ d.name }}</td>
            </tr>
        </table>
    </div>
</div>
